export const MEDIA_BLOCK = 'MediaBlock';
export const SURVEY_BLOCK = 'SurveyBlock';
export const EMBED_BLOCK = 'EmbedBlock';
export const CHOOSE_CHANNELS_BLOCK = 'ChooseChannels';

export const ATOMIC = 'atomic';
